var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMusicBand = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 800,
    viewBox: "0 0 1200 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5356_19183)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 49,
    width: 1101,
    height: 749,
    fill: "#3F5574"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 362,
    width: 306,
    height: 438,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.06 22.178C122.541 24.9971 117.525 33.7929 119.437 42.5601L126.98 77.1507C124.981 78.7535 124.083 81.4872 124.935 84.0627L127.911 93.0544C130.65 101.331 139.58 105.82 147.856 103.081L165.84 97.1301C174.116 94.3912 178.605 85.4613 175.866 77.1847L172.891 68.1931C172.039 65.6176 169.688 63.9589 167.127 63.8651L152.547 31.6033C148.851 23.4263 139.579 19.3589 131.06 22.178Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.377,
    cy: 89.6161,
    rx: 18.9424,
    ry: 7.89267,
    transform: "rotate(-18.3106 153.377 89.6161)",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.636 1C137.636 0.447715 137.189 0 136.636 0H129.364C128.811 0 128.364 0.447714 128.364 0.999999V14.7143C128.364 15.2666 127.916 15.7143 127.364 15.7143H117C116.448 15.7143 116 16.162 116 16.7143V43C116 43.5523 116.448 44 117 44H121.182C121.734 44 122.182 43.5523 122.182 43V23C122.182 22.4477 122.63 22 123.182 22H142.818C143.37 22 143.818 22.4477 143.818 23V43C143.818 43.5523 144.266 44 144.818 44H149C149.552 44 150 43.5523 150 43V16.7143C150 16.162 149.552 15.7143 149 15.7143H138.636C138.084 15.7143 137.636 15.2666 137.636 14.7143V1Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_5356_19183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.026 798H585.194C585.997 798 586.5 797.131 586.099 796.435L171.514 75.9572C171.215 75.4374 170.541 75.2757 170.038 75.6033L138.479 96.1873C138.181 96.3821 138.002 96.7158 138.006 97.0724L144.982 796.966C144.988 797.539 145.453 798 146.026 798Z",
    fill: "url(#paint0_linear_5356_19183)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 253,
    cy: 359.5,
    rx: 153,
    ry: 37.5,
    fill: "#454446"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.658 232.922L144.607 225.197C143.846 224.564 142.044 222.968 140.916 221.65C140.103 220.702 139.94 220.216 139.762 219.684C139.63 219.292 139.49 218.875 139.077 218.231C138.102 216.711 122.307 197.928 120.676 197.042C119.422 196.36 119.286 196.634 118.891 197.43C118.772 197.669 118.63 197.956 118.428 198.277C117.726 199.392 115.391 199.527 114.412 199.104C113.502 199.527 109.483 202.725 106.244 206.068C103.004 209.412 106.482 215.247 108.33 216.471C114.633 220.777 127.04 229.755 128.256 230.768C129.084 231.458 129.886 231.277 130.796 231.071C131.556 230.899 132.393 230.71 133.384 230.999C134.878 231.433 135.323 232.288 135.556 232.736L135.556 232.736C135.594 232.81 135.627 232.873 135.658 232.922ZM116.606 212.398C116.411 212.259 116.214 212.114 116.016 211.969C114.63 210.952 113.224 209.92 112.363 210.751C111.151 211.92 112.725 213.198 113.572 213.885C113.642 213.943 113.708 213.996 113.767 214.045C113.908 214.162 116.336 216.023 119.18 218.202L119.18 218.202C123.194 221.277 128.035 224.985 128.433 225.317C129.193 225.95 130.972 227.025 131.916 226.33C133.119 225.444 131.598 224.177 130.838 223.544C130.077 222.911 118.562 213.791 116.606 212.398ZM120.877 207.379C121.075 207.524 121.272 207.669 121.467 207.808C123.423 209.201 134.938 218.321 135.698 218.954C136.459 219.587 137.979 220.854 136.777 221.74C135.833 222.435 134.054 221.36 133.294 220.727C132.896 220.395 128.055 216.687 124.041 213.612C121.197 211.433 118.768 209.572 118.627 209.455C118.569 209.406 118.503 209.353 118.433 209.295C117.585 208.608 116.012 207.33 117.223 206.161C118.085 205.33 119.491 206.362 120.877 207.379Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.526 290.403C184.538 288.605 185.061 283.342 185.447 280.935C221.444 295.185 212.545 280.318 220.106 275.433C226.154 271.525 230.109 271.889 231.331 272.559L220.533 290.197L196.736 290.831C219.678 321.275 269.975 379.295 263.877 383.091C248.883 392.425 236.256 388.751 224.698 383.028C213.139 377.304 209.015 367.131 207.518 354.417C206.022 341.703 202.935 336.082 199.831 333.763C196.728 331.443 194.48 332.678 190.688 331.103C186.895 329.527 175.282 322.371 177.213 309.237C179.145 296.103 186.761 292.652 185.526 290.403Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.584 317.993C177.554 308.392 187.143 295.125 192.943 289.256C193.997 288.145 207.47 286.398 213.875 288.733C220.28 291.068 222.884 280.492 223.953 278.442C225.022 276.391 226.557 267.865 235.741 275.259C244.924 282.653 240.578 292.723 247.909 296.745C255.239 300.766 267.854 296.366 283.597 310.432C300.839 325.838 293.904 343.183 290.065 351.512C286.993 358.174 272.366 375.014 265.128 382.038C259.314 386.329 244.882 392.867 230.682 381.935C212.933 368.271 219.987 339.154 206.758 331.055C197.939 325.656 190.735 326.394 184.584 317.993Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.909 231.868L145.356 223.935C144.612 223.246 142.851 221.506 141.762 220.056C140.977 219.012 140.831 218.467 140.671 217.87C140.554 217.43 140.429 216.963 140.036 216.248C139.109 214.562 123.118 198.103 121.503 197.161C120.273 196.443 120.085 196.851 119.649 197.8C119.513 198.097 119.352 198.447 119.128 198.831C118.374 200.123 116.238 199.565 115.265 199.124C114.328 199.639 111.603 201.648 108.195 205.569C104.788 209.489 107.578 213.103 109.399 214.419C115.605 219.058 128.316 228.612 129.507 229.714C130.328 230.474 130.983 230.323 131.771 230.142C132.411 229.994 133.139 229.826 134.114 230.11C135.856 230.617 136.703 231.493 136.909 231.868ZM116.559 210.069L116.559 210.069C115.197 208.968 113.816 207.853 112.912 208.83C111.64 210.203 113.182 211.591 114.012 212.338C114.081 212.401 114.145 212.458 114.203 212.511C114.341 212.639 116.724 214.655 119.514 217.015L119.515 217.016C123.455 220.348 128.205 224.366 128.595 224.726C129.339 225.415 131.096 226.565 132.078 225.74C133.329 224.687 131.84 223.309 131.096 222.621C130.352 221.932 119.063 212.036 117.139 210.532C116.947 210.382 116.753 210.225 116.559 210.069ZM121.656 204.671C121.85 204.828 122.044 204.984 122.236 205.134C124.16 206.639 135.449 216.534 136.193 217.223C136.937 217.912 138.425 219.289 137.174 220.342C136.193 221.168 134.436 220.018 133.691 219.329C133.302 218.968 128.551 214.95 124.612 211.618C121.821 209.258 119.437 207.241 119.299 207.114C119.242 207.061 119.178 207.003 119.108 206.941C118.279 206.193 116.737 204.806 118.008 203.432C118.912 202.455 120.294 203.571 121.656 204.671Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.088 352.626L265.159 322.588C265.392 322.338 265.746 322.241 266.075 322.336L268.042 322.909C268.691 323.097 268.913 323.904 268.452 324.398L239.001 355.941C238.518 356.457 237.657 356.248 237.465 355.568L236.878 353.492C236.792 353.187 236.871 352.858 237.088 352.626Z",
    fill: "#22262A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.911 231.868L145.358 223.936L222.553 297.869L211.786 308.905L136.911 231.868Z",
    fill: "#22262A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 222.868,
    cy: 309.767,
    r: 12.697,
    transform: "rotate(16.22 222.868 309.767)",
    fill: "#22262A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.521 312.721C211.015 314.783 212.016 316.689 213.435 318.265C214.854 319.84 216.645 321.035 218.645 321.741C220.644 322.446 222.789 322.64 224.882 322.304C226.976 321.968 228.952 321.113 230.63 319.817C232.308 318.521 233.635 316.826 234.49 314.885C235.345 312.945 235.7 310.821 235.523 308.708C235.346 306.595 234.643 304.56 233.477 302.789C232.312 301.018 230.722 299.566 228.851 298.567L223.831 307.968C223.22 309.112 222.148 309.94 220.886 310.242L210.521 312.721Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.033 231.251L250.688 343.895",
    stroke: "#F9DCB9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.537 229.145L253.192 341.79",
    stroke: "#F9DCB9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.928 227.146L255.301 339.51",
    stroke: "#F9DCB9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.537 224.933L257.475 336.861",
    stroke: "#F9DCB9",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.864 216.915C115.182 216.563 115.155 216.019 114.802 215.701C114.45 215.383 113.907 215.41 113.589 215.762L113.345 216.033C113.033 216.377 112.515 216.423 112.109 216.199C110.804 215.481 109.508 215.397 108.909 216.092C108.134 216.991 108.817 218.85 110.434 220.245C112.052 221.64 113.991 222.042 114.766 221.143C115.288 220.537 115.148 219.494 114.505 218.451C114.269 218.069 114.272 217.57 114.573 217.237L114.864 216.915Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.101 207.683C130.852 207.912 130.835 208.3 131.064 208.55C131.293 208.799 131.681 208.816 131.93 208.587L132.042 208.484C132.331 208.219 132.769 208.222 133.099 208.434C133.949 208.981 134.818 209.102 135.274 208.664C135.885 208.077 135.523 206.711 134.468 205.613C133.412 204.514 132.061 204.099 131.451 204.686C131.059 205.062 131.068 205.76 131.403 206.502C131.565 206.86 131.524 207.295 131.235 207.561L131.101 207.683Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.616 222.676C120.897 222.286 120.809 221.742 120.419 221.461C120.029 221.179 119.485 221.267 119.204 221.657L118.981 221.965C118.71 222.342 118.2 222.445 117.772 222.266C116.375 221.684 115.057 221.743 114.529 222.511C113.849 223.502 114.743 225.298 116.527 226.524C118.311 227.749 120.309 227.939 120.99 226.948C121.451 226.277 121.19 225.237 120.42 224.255C120.142 223.901 120.091 223.404 120.354 223.04L120.616 222.676Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.696 203.481C126.504 203.767 126.58 204.154 126.866 204.346C127.152 204.537 127.539 204.461 127.731 204.175L127.817 204.046C128.039 203.715 128.473 203.614 128.849 203.744C129.821 204.082 130.709 203.993 131.054 203.451C131.517 202.725 130.833 201.463 129.527 200.63C128.221 199.798 126.788 199.712 126.325 200.437C126.029 200.902 126.204 201.589 126.712 202.241C126.958 202.556 127.021 202.995 126.798 203.328L126.696 203.481Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M127.786 227.556C128.11 227.24 128.116 226.721 127.8 226.397C127.484 226.073 126.965 226.066 126.641 226.383L126.42 226.598C126.088 226.922 125.568 226.935 125.175 226.689C123.986 225.944 122.774 225.795 122.168 226.415C121.376 227.224 121.914 229.035 123.37 230.46C124.826 231.886 126.649 232.385 127.441 231.576C127.969 231.036 127.905 230.049 127.37 229.028C127.161 228.63 127.195 228.132 127.517 227.818L127.786 227.556Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.24 213.33C135.948 213.555 135.893 213.974 136.118 214.267C136.343 214.559 136.762 214.613 137.055 214.388L137.187 214.287C137.525 214.026 138.001 214.071 138.339 214.333C139.211 215.006 140.142 215.219 140.678 214.787C141.396 214.208 141.132 212.691 140.09 211.4C139.048 210.108 137.621 209.531 136.904 210.11C136.443 210.482 136.387 211.239 136.68 212.075C136.823 212.48 136.737 212.948 136.397 213.209L136.24 213.33Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.657 232.92L136.908 231.868L192.942 289.255L191.565 290.743L135.657 232.92Z",
    fill: "#050505"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 841,
    y: 294,
    width: 259,
    height: 504,
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.57 24.1428C1088.32 28.457 1091.7 38.0006 1088.41 46.2578L1075.41 78.8362C1077.07 80.7724 1077.48 83.6184 1076.23 85.9913L1071.88 94.2755C1067.87 101.901 1058.51 104.685 1050.98 100.493L1034.63 91.3862C1027.1 87.1948 1024.25 77.6153 1028.26 69.9898L1032.62 61.7056C1033.87 59.3327 1036.41 58.1318 1038.89 58.5049L1058.29 29.4903C1063.21 22.1363 1072.82 19.8286 1080.57 24.1428Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7208,
    cy: 7.80031,
    rx: 18.7208,
    ry: 7.80031,
    transform: "matrix(-0.873696 -0.486473 -0.465523 0.885036 1067.88 88.4781)",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1066.91 1C1066.91 0.447715 1067.36 0 1067.91 0H1075.19C1075.74 0 1076.19 0.447714 1076.19 0.999999V14.7143C1076.19 15.2666 1076.63 15.7143 1077.19 15.7143H1087.55C1088.1 15.7143 1088.55 16.162 1088.55 16.7143V43C1088.55 43.5523 1088.1 44 1087.55 44H1083.37C1082.82 44 1082.37 43.5523 1082.37 43V23C1082.37 22.4477 1081.92 22 1081.37 22H1061.73C1061.18 22 1060.73 22.4477 1060.73 23V43C1060.73 43.5523 1060.28 44 1059.73 44H1055.55C1055 44 1054.55 43.5523 1054.55 43V16.7143C1054.55 16.162 1055 15.7143 1055.55 15.7143H1065.91C1066.47 15.7143 1066.91 15.2666 1066.91 14.7143V1Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.955 25.0061C413.998 28.3387 409.617 37.3963 411.803 45.9949L418.19 72.4065C416.362 74.1245 415.628 76.8984 416.546 79.4063L419.751 88.162C422.7 96.2213 431.359 100.13 439.09 96.8922L455.887 89.8571C463.618 86.6193 467.493 77.4612 464.543 69.4019L461.339 60.6462C460.421 58.1383 458.121 56.6352 455.689 56.7011L442.73 33.0424C438.877 25.1415 429.912 21.6735 421.955 25.0061Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.211,
    cy: 14.3623,
    rx: 18.211,
    ry: 14.3623,
    transform: "matrix(0.92237 -0.386307 0.343717 0.939073 419.75 70.5167)",
    fill: "#F3988B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.145 1C433.145 0.447715 432.698 0 432.145 0H425.691C425.138 0 424.691 0.447714 424.691 0.999999V14.7143C424.691 15.2666 424.243 15.7143 423.691 15.7143H414.418C413.866 15.7143 413.418 16.162 413.418 16.7143V43C413.418 43.5523 413.866 44 414.418 44H418.054C418.607 44 419.054 43.5523 419.054 43V23C419.054 22.4477 419.502 22 420.054 22H437.782C438.334 22 438.782 22.4477 438.782 23V43C438.782 43.5523 439.229 44 439.782 44H443.418C443.97 44 444.418 43.5523 444.418 43V16.7143C444.418 16.162 443.97 15.7143 443.418 15.7143H434.145C433.593 15.7143 433.145 15.2666 433.145 14.7143V1Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M757.372 24.3513C766.203 25.1706 773.148 32.5372 773.467 41.4217L774.774 68.6131C777.077 69.7134 778.603 72.1505 778.419 74.8253L777.777 84.1636C777.185 92.7592 769.751 99.0821 761.172 98.2862L742.531 96.5567C733.952 95.7607 727.477 88.1473 728.068 79.5516L728.711 70.2133C728.895 67.5385 730.735 65.4139 733.159 64.7522L739.147 38.2375C740.677 29.5246 748.542 23.5321 757.372 24.3513Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7208,
    cy: 14.4188,
    rx: 18.7208,
    ry: 14.4188,
    transform: "matrix(-0.995724 -0.0923827 -0.0686379 0.997642 772.686 67.2686)",
    fill: "#88C4BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.661 1C751.661 0.447715 752.109 0 752.661 0H760.206C760.759 0 761.206 0.447714 761.206 0.999999V14.7143C761.206 15.2666 761.654 15.7143 762.206 15.7143H772.934C773.486 15.7143 773.934 16.162 773.934 16.7143V43C773.934 43.5523 773.486 44 772.934 44H768.57C768.018 44 767.57 43.5523 767.57 43V23C767.57 22.4477 767.122 22 766.57 22H746.297C745.745 22 745.297 22.4477 745.297 23V43C745.297 43.5523 744.85 44 744.297 44H739.934C739.381 44 738.934 43.5523 738.934 43V16.7143C738.934 16.162 739.381 15.7143 739.934 15.7143H750.661C751.213 15.7143 751.661 15.2666 751.661 14.7143V1Z",
    fill: "#6A87AE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_5356_19183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M384.491 769.474L848.168 605.97C848.83 605.736 849.078 604.929 848.661 604.364L455.9 72.5419C455.657 72.212 455.242 72.0552 454.841 72.1412L428.273 77.8344C427.816 77.9324 427.479 78.3221 427.449 78.7886L383.101 768.422C383.053 769.17 383.785 769.723 384.491 769.474Z",
    fill: "url(#paint1_linear_5356_19183)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_5356_19183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.746 761.5H852.318C852.946 761.5 853.432 760.95 853.354 760.327L769.114 81.4158C769.049 80.8927 768.604 80.5 768.077 80.5L736.125 80.5C735.74 80.5 735.386 80.7115 735.205 81.0505L370.826 759.962C370.452 760.657 370.956 761.5 371.746 761.5Z",
    fill: "url(#paint2_linear_5356_19183)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter3_f_5356_19183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.845 656.922L1004.82 782.231C1005.44 782.373 1006.05 781.931 1006.1 781.296L1060.94 94.7296C1060.98 94.2916 1060.73 93.8786 1060.33 93.6962L1033.16 81.3002C1032.76 81.1196 1032.3 81.2035 1031.99 81.5107L456.341 655.164C455.758 655.744 456.044 656.739 456.845 656.922Z",
    fill: "url(#paint3_linear_5356_19183)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 400,
    width: 499,
    height: 400,
    fill: "#212122"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 651,
    cy: 405.5,
    rx: 250,
    ry: 53.5,
    fill: "#454446"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 970,
    cy: 293.5,
    rx: 130,
    ry: 32.5,
    fill: "#454446"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 660,
    width: 303,
    height: 139,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.5,
    cy: 663.5,
    rx: 151.5,
    ry: 41.5,
    fill: "#454446"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652.75,
    y: 254.833,
    width: 6.61843,
    height: 41.9167,
    rx: 3.30922,
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 643.926,
    y: 254.833,
    width: 6.61843,
    height: 41.9167,
    rx: 3.30922,
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 732.625,
    y: 343.38,
    width: 6.61843,
    height: 44.752,
    rx: 3.30922,
    transform: "rotate(-25.2281 732.625 343.38)",
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.94736,
    height: 56.8833,
    rx: 3.47368,
    transform: "matrix(-0.806727 -0.590925 -0.649317 0.760518 575.17 340.033)",
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.10992,
    height: 55.4709,
    rx: 3.55496,
    transform: "matrix(-0.969331 0.245758 0.283397 0.959003 570.848 340.873)",
    fill: "#5CBCD1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.4,
    y: 257.039,
    width: 6.61843,
    height: 41.9167,
    rx: 3.30922,
    transform: "rotate(90 670.4 257.039)",
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M704.739 222.374C704.723 222.333 704.707 222.291 704.689 222.25C704.672 222.209 704.653 222.168 704.635 222.128L704.326 221.4L704.228 221.442C701.071 217.15 688.911 217.893 676.034 223.353C663.156 228.812 654.168 237.036 655.058 242.289L654.955 242.332L670.277 278.472L719.648 257.539L704.739 222.374Z",
    fill: "#EA7362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M718.318 257.807C718.418 258.044 718.416 258.675 717.487 259.894C716.618 261.036 715.156 262.391 713.162 263.87C709.188 266.818 703.303 270.105 696.452 273.01C689.601 275.915 683.146 277.859 678.265 278.666C675.815 279.071 673.824 279.179 672.4 279.011C670.878 278.83 670.423 278.393 670.322 278.156C670.222 277.919 670.224 277.288 671.153 276.069C672.021 274.928 673.484 273.572 675.478 272.093C679.452 269.146 685.337 265.858 692.188 262.953C699.039 260.048 705.494 258.104 710.375 257.297C712.824 256.892 714.816 256.784 716.24 256.953C717.762 257.133 718.217 257.57 718.318 257.807Z",
    fill: "#F9DCB9",
    stroke: "#5CBCD1",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M638.821 247.184C638.84 247.131 638.858 247.077 638.875 247.022C638.891 246.968 638.907 246.913 638.921 246.859L639.146 246.132L639.044 246.1C639.398 240.75 629.561 233.434 616.112 229.28C602.663 225.127 590.413 225.622 587.689 230.24L587.58 230.207L575.923 267.952L627.489 283.877L638.821 247.184Z",
    fill: "#EA7362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.056 283.659C626.968 283.945 626.527 284.444 625.027 284.796C623.613 285.128 621.604 285.239 619.107 285.097C614.13 284.815 607.466 283.545 600.311 281.336C593.157 279.126 586.937 276.417 582.668 273.844C580.526 272.553 578.929 271.328 577.949 270.257C576.908 269.12 576.826 268.46 576.914 268.173C577.003 267.887 577.443 267.388 578.943 267.036C580.357 266.704 582.366 266.593 584.863 266.735C589.84 267.017 596.504 268.287 603.659 270.496C610.813 272.706 617.033 275.415 621.302 277.988C623.445 279.279 625.041 280.504 626.022 281.575C627.062 282.712 627.145 283.372 627.056 283.659Z",
    fill: "#F9DCB9",
    stroke: "#5CBCD1",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 747.658,
    cy: 190.676,
    rx: 33.4019,
    ry: 12.3296,
    transform: "rotate(-13.286 747.658 190.676)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.581 191.554C778.358 189.216 779.959 186.878 780.243 184.748C780.527 182.618 779.485 180.761 777.21 179.342C774.934 177.923 771.495 176.986 767.198 176.613C762.9 176.24 757.876 176.443 752.571 177.204C747.266 177.966 741.844 179.262 736.784 180.977C731.725 182.693 727.184 184.776 723.565 187.041C719.946 189.306 717.36 191.683 716.036 193.963C714.711 196.242 714.69 198.353 715.974 200.108L739.628 193.066C739.303 192.621 739.308 192.086 739.643 191.509C739.979 190.931 740.634 190.329 741.552 189.755C742.469 189.18 743.62 188.653 744.902 188.218C746.184 187.783 747.558 187.455 748.903 187.262C750.248 187.069 751.521 187.017 752.61 187.112C753.699 187.206 754.571 187.444 755.147 187.803C755.724 188.163 755.988 188.634 755.916 189.173C755.844 189.713 755.438 190.306 754.735 190.898L775.581 191.554Z",
    fill: "#E4BD70"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 561.674,
    cy: 211.647,
    rx: 33.4019,
    ry: 12.3296,
    transform: "rotate(7.1294 561.674 211.647)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.535 213.477C593.782 211.374 591.708 209.229 588.496 207.233C585.285 205.236 581.035 203.45 576.123 202.031C571.211 200.613 565.789 199.606 560.337 199.101C554.886 198.595 549.572 198.606 544.867 199.133C540.163 199.66 536.213 200.686 533.367 202.121C530.52 203.556 528.866 205.354 528.551 207.358C528.235 209.362 529.268 211.509 531.557 213.609C533.846 215.708 537.322 217.696 541.676 219.396L561.674 211.647L594.535 213.477Z",
    fill: "#E4BD70"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 560.471,
    y: 215.35,
    width: 5.85758,
    height: 135.561,
    rx: 2.92879,
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535.994,
    y: 284.616,
    width: 70.5966,
    height: 21.0787,
    transform: "rotate(8.1341 535.994 284.616)",
    fill: "#C13925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.865 294.25C603.304 294.425 603.669 294.587 603.965 294.735C603.64 294.794 603.244 294.847 602.773 294.891C601.018 295.057 598.462 295.076 595.272 294.946C588.904 294.687 580.15 293.84 570.526 292.464C560.901 291.089 552.261 289.449 546.075 287.914C542.976 287.145 540.528 286.411 538.889 285.76C538.45 285.586 538.085 285.424 537.79 285.276C538.114 285.217 538.51 285.164 538.981 285.12C540.736 284.954 543.292 284.935 546.482 285.065C552.85 285.324 561.604 286.171 571.229 287.546C580.853 288.922 589.493 290.562 595.679 292.097C598.778 292.866 601.226 293.6 602.865 294.25Z",
    fill: "#F9DCB9",
    stroke: "#5CBCD1",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 568.107,
    cy: 309.386,
    rx: 35.2983,
    ry: 7.7215,
    transform: "rotate(8.1341 568.107 309.386)",
    fill: "#C13925"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 745.408,
    y: 188.649,
    width: 6.61843,
    height: 101.483,
    rx: 3.30922,
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 699.156,
    y: 283.711,
    width: 70.5966,
    height: 55.1536,
    transform: "rotate(-0.0396141 699.156 283.711)",
    fill: "#C13925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.742 284.557C767.064 284.628 767.349 284.699 767.6 284.768C767.35 284.837 767.064 284.908 766.743 284.979C765.024 285.362 762.492 285.715 759.314 286.015C752.971 286.614 744.183 286.99 734.458 286.997C724.734 287.003 715.945 286.64 709.601 286.049C706.423 285.754 703.891 285.404 702.171 285.024C701.85 284.953 701.564 284.882 701.314 284.813C701.564 284.744 701.849 284.673 702.171 284.602C703.89 284.219 706.421 283.866 709.599 283.566C715.943 282.967 724.731 282.591 734.455 282.584C744.18 282.578 752.968 282.941 759.313 283.532C762.491 283.827 765.023 284.177 766.742 284.557Z",
    fill: "#F9DCB9",
    stroke: "#5CBCD1",
    strokeWidth: 2.20614
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 734.495,
    cy: 339.944,
    rx: 35.2983,
    ry: 7.7215,
    transform: "rotate(-0.0396141 734.495 339.944)",
    fill: "#C13925"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M580.563 306.261C593.668 292.522 611.442 284.804 629.975 284.804V358.064L629.975 431.324C611.442 431.324 593.668 423.606 580.563 409.867C567.458 396.128 560.096 377.494 560.096 358.064C560.096 338.634 567.458 320 580.563 306.261ZM663.787 284.804H629.975V431.324H663.787V284.804Z",
    fill: "#EA7362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.458 358.064C731.458 397.406 701.063 429.118 663.785 429.118C626.508 429.118 596.112 397.406 596.112 358.064C596.112 318.723 626.508 287.01 663.785 287.01C701.063 287.01 731.458 318.723 731.458 358.064Z",
    fill: "#F9DCB9",
    stroke: "#5CBCD1",
    strokeWidth: 4.41229
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425,
    y: 759,
    width: 234,
    height: 41,
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 542,
    cy: 763,
    rx: 117,
    ry: 20,
    fill: "#454446"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 540.5,
    cy: 761.627,
    rx: 38.5,
    ry: 11,
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.585 752.105C533.02 751.327 532.098 750.889 531.139 750.957C525.97 751.328 521.12 752.001 516.9 752.936C512.264 753.964 508.512 755.281 505.929 756.786C503.347 758.291 502.003 759.946 502 761.622C501.997 763.299 503.336 764.953 505.913 766.459C508.491 767.965 512.239 769.283 516.872 770.312C521.505 771.341 526.899 772.054 532.643 772.396C538.388 772.738 544.33 772.7 550.015 772.286C551.166 772.202 552.3 772.103 553.414 771.99C556.932 771.632 557.229 767.245 553.877 766.119C553.246 765.907 552.569 765.882 551.918 766.021C549.921 766.444 547.651 766.753 545.234 766.93C542.405 767.136 539.449 767.154 536.592 766.984C533.734 766.814 531.05 766.459 528.746 765.948C526.441 765.436 524.577 764.78 523.294 764.031C522.012 763.282 521.346 762.459 521.348 761.625C521.349 760.791 522.017 759.968 523.302 759.219C524.587 758.47 526.454 757.815 528.76 757.304C529.621 757.113 530.536 756.944 531.492 756.798C533.693 756.463 534.893 753.906 533.585 752.105Z",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 539,
    cy: 753.627,
    rx: 9,
    ry: 4,
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530,
    y: 748.627,
    width: 18,
    height: 5,
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 539,
    cy: 748.627,
    rx: 9,
    ry: 3,
    fill: "#9DA4AF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 535,
    y: 566,
    width: 7,
    height: 184,
    rx: 3.5,
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535 569C535 567.343 536.343 566 538 566V750C536.343 750 535 748.657 535 747V569Z",
    fill: "#818A98"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 566.14,
    cy: 547.656,
    rx: 21.5,
    ry: 20.2127,
    transform: "rotate(-21.365 566.14 547.656)",
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.667 544.255C547.319 543.77 544.939 545.208 544.827 547.604C544.751 549.259 544.884 550.914 545.23 552.532C545.87 555.529 547.221 558.319 549.18 560.692C551.139 563.065 553.656 564.959 556.54 566.232C559.424 567.504 562.601 568.121 565.83 568.037C569.059 567.952 572.257 567.168 575.182 565.744C578.108 564.32 580.684 562.292 582.717 559.815C584.75 557.337 586.186 554.474 586.918 551.441C587.276 549.958 587.461 548.453 587.473 546.954C587.493 544.376 584.898 542.832 582.401 543.474C579.959 544.102 578.569 546.634 578.131 549.117C578.09 549.35 578.042 549.582 577.986 549.814C577.569 551.543 576.75 553.175 575.591 554.588C574.432 556 572.963 557.156 571.295 557.968C569.628 558.78 567.804 559.227 565.963 559.275C564.122 559.323 562.311 558.971 560.667 558.246C559.023 557.521 557.588 556.441 556.471 555.088C555.354 553.735 554.584 552.144 554.219 550.436C554.187 550.283 554.157 550.131 554.131 549.977C553.697 547.412 552.216 544.781 549.667 544.255Z",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.238 538.627C556.073 539.531 563 548.144 563 558.635C563 561.868 562.343 564.922 561.174 567.627C554.411 566.884 548.502 562.375 546.093 555.225C544.243 549.735 544.819 543.763 547.238 538.627Z",
    fill: "#9DA4AF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M545.114 546.232C544.81 549.233 545.106 552.298 546.093 555.225C548.502 562.376 554.411 566.884 561.174 567.627C562.212 565.225 562.847 562.547 562.976 559.713C556.303 560.458 549.243 556.098 546 548.667C545.648 547.862 545.354 547.048 545.114 546.232Z",
    fill: "#818A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.5 563.627C559.9 553.227 551.5 544.127 546 544.127L505.5 567.127L511.5 578.627L551.5 563.627Z",
    fill: "#EA7362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.5 563.627C556.5 557.127 555 553.627 554.5 551.627L509.5 574.627L511.5 578.627L551.5 563.627Z",
    fill: "#EA462F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 509.072,
    cy: 572.592,
    rx: 5,
    ry: 6.58812,
    transform: "rotate(-21.5778 509.072 572.592)",
    fill: "#C13925"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.546 560.915L544.979 555.641C546.477 555.005 548.316 555.19 548.729 556.764C549.704 560.486 547.895 567.277 545.744 569.284C543.037 571.811 536.538 574.338 532.206 575.349C530.723 575.695 529.122 575.683 527.647 575.504C526.156 575.322 526.102 573.178 527.332 572.316C528.533 571.476 529.109 568.324 529.351 565.514C529.522 563.514 530.698 561.699 532.546 560.915Z",
    fill: "#9DA4AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.552 681.376L207.7 676.205C206.743 676.139 206 675.344 206 674.385C206 673.337 206.881 672.504 207.928 672.564L283.833 676.877C285.026 676.944 285.959 677.932 285.959 679.127C285.959 680.433 284.854 681.465 283.552 681.376Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.756 681.459L206.637 676.132C206.279 676.108 206 675.81 206 675.45C206 675.057 206.33 674.745 206.723 674.767L284.896 679.209C285.493 679.243 285.959 679.736 285.959 680.334C285.959 680.987 285.407 681.503 284.756 681.459Z",
    fill: "#B1690F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 287.776,
    cy: 679.723,
    r: 7.72335,
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.95 676.921C281.324 676.62 280.561 676.882 280.365 677.549C279.973 678.887 279.947 680.314 280.304 681.677C280.767 683.449 281.845 684.999 283.346 686.05C284.846 687.1 286.671 687.584 288.494 687.413C289.898 687.282 291.23 686.771 292.353 685.945C292.913 685.533 292.898 684.726 292.401 684.241C291.904 683.755 291.112 683.781 290.522 684.147C289.842 684.569 289.068 684.832 288.26 684.907C287.031 685.022 285.801 684.696 284.789 683.988C283.778 683.28 283.051 682.235 282.739 681.041C282.533 680.255 282.516 679.439 282.68 678.655C282.823 677.975 282.576 677.222 281.95 676.921Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 719,
    width: 402,
    height: 81,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 901,
    cy: 715.5,
    rx: 201,
    ry: 60.5,
    fill: "#454446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.8 161.141L1100.43 163.363L1099.11 167.377L1092.5 166.075L1093.8 161.141Z",
    fill: "#ED972C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1025.25,
    y: 178.701,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 1025.25 178.701)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1016.3,
    y: 191.382,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 1016.3 191.382)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1008.52,
    y: 205.84,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 1008.52 205.84)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 999.762,
    y: 220.639,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 999.762 220.639)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 991.65,
    y: 234.939,
    width: 5.46782,
    height: 5.1033,
    transform: "rotate(25.7481 991.65 234.939)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1023.38,
    y: 173.348,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 1023.38 173.348)",
    fill: "#ED972C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1014.43,
    y: 186.029,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 1014.43 186.029)",
    fill: "#ED972C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1006.65,
    y: 200.487,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 1006.65 200.487)",
    fill: "#ED972C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 997.891,
    y: 215.285,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 997.891 215.285)",
    fill: "#ED972C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 989.781,
    y: 229.585,
    width: 4.73878,
    height: 11.3002,
    rx: 2.36939,
    transform: "rotate(25.7481 989.781 229.585)",
    fill: "#ED972C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1055.24 161.4C1060.62 158.975 1078.92 164.051 1088.41 166.47L1090.79 161.545C1084.07 159.385 1067.94 153.964 1057.79 151.5C1047.95 149.109 1042.43 154.545 1040.36 158.27L985.678 250.675C983.432 255.191 977.27 263.577 970.581 260.999C963.892 258.42 966.095 250.539 967.842 246.12C972.746 233.714 983.389 202.221 981.774 194.158C980.159 186.094 980.816 186.074 981.64 184.785C985.954 180.876 983.01 179.847 980.999 179.822C962.677 183.126 924.623 190.228 918.978 192.2C913.332 194.172 915.2 195.977 916.84 196.632C930.257 200.028 928.91 210.346 926.559 215.08C908.013 280.803 923.4 290.855 942.901 297.832C957.659 303.112 977.135 291.882 985.903 277.899C994.67 263.916 1045.93 171.478 1045.93 171.478C1049.51 165.313 1052.64 162.573 1055.24 161.4Z",
    fill: "#DCA130"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.17 159.716C1057.17 157.464 1063.36 158.801 1071.82 160.941C1072.8 161.189 1073.74 160.414 1073.68 159.405C1073.65 158.864 1073.32 158.382 1072.83 158.149C1067.89 155.789 1064.42 154.451 1056.36 153.64C1046.28 152.625 1043.76 158.423 1041.69 162.148L987.98 254.214C981.118 264.664 975.937 275.999 965.102 267.664C958.756 262.782 958.194 254.417 961.217 246.77C966.122 234.363 972.13 217.431 974.04 208.436C975.462 201.736 975.289 194.403 975.668 191.396C975.776 190.542 976.321 189.867 976.914 189.243C979.396 186.636 978.275 185.74 976.765 185.5C976.154 185.403 975.534 185.481 974.924 185.59C956.769 188.829 934.71 191.731 929.158 193.67C923.512 195.641 925.38 197.446 927.02 198.102C940.437 201.498 934.818 215.218 932.467 219.953C909.803 277.012 940.319 289.68 944.979 291.347C958.785 296.286 971.724 289.677 981.847 275.74C991.648 262.247 1040.24 176.414 1043.32 170.968C1043.43 170.785 1043.52 170.602 1043.61 170.413C1046.06 165.434 1049.62 160.867 1052.17 159.716Z",
    fill: "#E4BD70"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1091.77,
    y: 155.743,
    width: 5.83235,
    height: 15.3099,
    rx: 2.91617,
    transform: "rotate(25.7481 1091.77 155.743)",
    fill: "#F5D08A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1091.79,
    y: 157.373,
    width: 3.28069,
    height: 9.11304,
    rx: 1.64035,
    transform: "rotate(25.7481 1091.79 157.373)",
    fill: "#EFDCA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.054 231.847C936.936 225.873 938.364 219.39 938.999 214.114C939.597 209.133 944.937 203.588 947.07 208.13C948.445 211.059 948.061 216.688 943.119 227.316C932.284 250.622 932.895 264.879 934.703 271.619C936.511 278.359 948.798 293.998 936.144 281.217C923.489 268.436 927.878 244.652 934.054 231.847Z",
    fill: "#EFDCA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.28 164.409C1045.72 161.939 1047.24 160.3 1048.67 159.24C1051.53 157.112 1054.24 154.891 1050.8 155.815C1048.88 156.328 1046.69 157.419 1045.27 159.015C1041.74 162.978 1039.59 172.464 1044.28 164.409Z",
    fill: "#EFDCA9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.065 286.867C956.239 288.051 952.689 287.938 949.377 288.019C946.121 288.098 950.969 291.474 955.363 291.092C959.756 290.711 962.783 285.309 959.065 286.867Z",
    fill: "#EFDCA9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1100,
    y: 615.51,
    width: 99.908,
    height: 184.49,
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.88 600H1199.91V615.51H1100L1122.88 600Z",
    fill: "#818A98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1104.88 615.51H1109.45V789.009H1191.05V615.51H1195.63V793.72H1191.05L1109.45 793.72L1104.88 793.719V615.51Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.55,
    cy: 672.653,
    rx: 25.9923,
    ry: 26.1224,
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.17 672.653C1170.17 684.101 1160.93 693.377 1149.55 693.377C1138.16 693.377 1128.93 684.101 1128.93 672.653C1128.93 661.205 1138.16 651.928 1149.55 651.928C1160.93 651.928 1170.17 661.205 1170.17 672.653Z",
    fill: "#818A98",
    stroke: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.14,
    cy: 673.061,
    rx: 7.71647,
    ry: 7.7551,
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.6 666.686C1153.71 667.278 1154.65 668.149 1155.33 669.215C1156 670.281 1156.39 671.504 1156.45 672.766C1156.52 674.027 1156.25 675.284 1155.69 676.413C1155.13 677.542 1154.28 678.504 1153.23 679.206C1152.19 679.908 1150.98 680.326 1149.73 680.418C1148.47 680.51 1147.22 680.274 1146.08 679.733C1144.95 679.191 1143.97 678.363 1143.25 677.329C1142.53 676.294 1142.08 675.09 1141.97 673.832L1142.81 673.862C1147.34 674.02 1151.38 671.058 1152.6 666.686Z",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.55,
    cy: 742.041,
    rx: 32.4904,
    ry: 32.6531,
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1175.45 742.041C1175.45 756.42 1163.85 768.071 1149.55 768.071C1135.25 768.071 1123.65 756.42 1123.65 742.041C1123.65 727.662 1135.25 716.01 1149.55 716.01C1163.85 716.01 1175.45 727.662 1175.45 742.041Z",
    fill: "#818A98",
    stroke: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1149.04,
    cy: 742.551,
    rx: 9.64559,
    ry: 9.69388,
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1153.41 734.479C1154.81 735.227 1155.99 736.327 1156.85 737.672C1157.7 739.017 1158.19 740.561 1158.27 742.154C1158.35 743.746 1158.02 745.333 1157.3 746.758C1156.59 748.183 1155.52 749.397 1154.21 750.284C1152.89 751.17 1151.36 751.697 1149.78 751.813C1148.2 751.93 1146.61 751.632 1145.18 750.948C1143.74 750.265 1142.51 749.219 1141.6 747.914C1140.69 746.608 1140.13 745.087 1139.98 743.5L1142.96 743.604C1147.55 743.765 1151.65 740.759 1152.89 736.323L1153.41 734.479Z",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.49,
    cy: 777.143,
    rx: 6.49808,
    ry: 6.53061,
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1119.49,
    cy: 777.143,
    rx: 4.87356,
    ry: 4.89796,
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1128.43,
    y: 622.857,
    width: 42.2375,
    height: 15.5102,
    rx: 5,
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.17 664.56L1123 674.5L1124.06 682.497L1109 672L1111.04 680.877L1083.68 663.806L1104.55 673.467L1103.17 664.56Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.82 765.239L1119.21 757.396L1122.5 762.5L1104.32 765.239L1115.81 769.549L1078.32 781.239L1103.32 769.549L1092.82 765.239Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 183.567,
    transform: "matrix(-1 0 0 1 100 616.433)",
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.0992 601H0V616.433H100L77.0992 601Z",
    fill: "#818A98"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.1211 616.433H90.5409V789.064H8.86403V616.433H4.28387V793.751L8.86403 793.751H90.5434L95.1211 793.751V616.433Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.0163,
    cy: 25.9918,
    rx: 26.0163,
    ry: 25.9918,
    transform: "matrix(-1 0 0 1 76.4238 647.298)",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7724 673.29C29.7724 684.677 39.012 693.908 50.4106 693.908C61.8092 693.908 71.0488 684.677 71.0488 673.29C71.0488 661.903 61.8092 652.671 50.4106 652.671C39.012 652.671 29.7724 661.903 29.7724 673.29Z",
    fill: "#818A98",
    stroke: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.72358,
    cy: 7.71633,
    rx: 7.72358,
    ry: 7.71633,
    transform: "matrix(-1 0 0 1 58.5371 665.98)",
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3525 667.352C46.2412 667.941 45.3019 668.809 44.6264 669.869C43.9509 670.929 43.5623 672.147 43.4986 673.402C43.4349 674.657 43.6982 675.908 44.2629 677.031C44.8275 678.154 45.6742 679.112 46.7201 679.81C47.766 680.509 48.9754 680.924 50.2302 681.016C51.4849 681.108 52.742 680.873 53.8786 680.334C55.0153 679.795 55.9925 678.971 56.715 677.942C57.4374 676.913 57.8803 675.714 58.0003 674.463L57.1347 674.493C52.6177 674.65 48.5773 671.701 47.3525 667.352Z",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5203,
    cy: 32.4898,
    rx: 32.5203,
    ry: 32.4898,
    transform: "matrix(-1 0 0 1 82.9277 709.841)",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4826 742.331C24.4826 756.633 36.0882 768.229 50.4054 768.229C64.7226 768.229 76.3281 756.633 76.3281 742.331C76.3281 728.028 64.7226 716.433 50.4054 716.433C36.0882 716.433 24.4826 728.028 24.4826 742.331Z",
    fill: "#818A98",
    stroke: "#F1F2F4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.65447,
    cy: 9.64541,
    rx: 9.65447,
    ry: 9.64541,
    transform: "matrix(-1 0 0 1 60.5703 733.192)",
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5426 734.807C45.1398 735.551 43.9541 736.645 43.1015 737.984C42.2488 739.322 41.7582 740.859 41.6778 742.443C41.5974 744.028 41.9298 745.606 42.6425 747.024C43.3553 748.442 44.4241 749.651 45.7444 750.532C47.0646 751.414 48.5913 751.939 50.1751 752.055C51.759 752.17 53.3458 751.874 54.7806 751.194C56.2154 750.514 57.4491 749.473 58.361 748.174C59.2729 746.875 59.832 745.362 59.9835 743.783L57.0286 743.886C52.4198 744.046 48.2972 741.037 47.0476 736.6L46.5426 734.807Z",
    fill: "#B9BEC6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.50407,
    cy: 6.49796,
    rx: 6.50407,
    ry: 6.49796,
    transform: "matrix(-1 0 0 1 86.9941 770.759)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.87805,
    cy: 4.87347,
    rx: 4.87805,
    ry: 4.87347,
    transform: "matrix(-1 0 0 1 85.3691 772.384)",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 42.2764,
    height: 15.4327,
    rx: 5,
    transform: "matrix(-1 0 0 1 71.543 623.743)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.49 653.56L78.1169 663.5L77.0771 671.497L91.7912 661L89.7981 669.877L116.522 652.806L96.1348 662.467L97.49 653.56Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.592 754.239L81.8191 746.396L78.6051 751.5L96.3599 754.239L85.1389 758.549L121.755 770.239L97.3367 758.549L107.592 754.239Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.7101,
    cy: 562.258,
    rx: 41.2762,
    ry: 42.6505,
    transform: "rotate(33.9574 61.7101 562.258)",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1288 528.822C81.482 527.589 81.5887 526.297 81.4429 525.022C81.297 523.747 80.9015 522.514 80.2789 521.392C79.6563 520.27 78.8187 519.281 77.8141 518.483C76.8095 517.684 75.6574 517.092 74.4237 516.738C73.19 516.385 71.8989 516.279 70.6239 516.424C69.349 516.57 68.1152 516.966 66.9932 517.588C65.8711 518.211 64.8826 519.048 64.0842 520.053C63.2858 521.058 62.6931 522.21 62.3399 523.443L71.7344 526.133L81.1288 528.822Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1191 524.202C55.5098 523.072 54.684 522.074 53.6889 521.264C52.6937 520.453 51.5487 519.847 50.3193 519.479C49.0899 519.112 47.8 518.99 46.5235 519.121C45.2469 519.251 44.0086 519.632 42.8792 520.242C41.7499 520.851 40.7516 521.677 39.9414 522.672C39.1312 523.667 38.5249 524.812 38.1572 526.041C37.7895 527.271 37.6675 528.561 37.7983 529.837C37.929 531.114 38.3099 532.352 38.9193 533.481L47.5192 528.842L56.1191 524.202Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.98 535.836C36.9647 535.051 35.8047 534.474 34.5664 534.137C33.328 533.801 32.0355 533.712 30.7627 533.875C29.4898 534.038 28.2616 534.45 27.148 535.088C26.0344 535.725 25.0574 536.576 24.2726 537.591C23.4879 538.607 22.9108 539.767 22.5743 541.005C22.2379 542.243 22.1486 543.536 22.3117 544.809C22.4747 546.082 22.8869 547.31 23.5246 548.424C24.1624 549.537 25.0132 550.514 26.0285 551.299L32.0043 543.567L37.98 535.836Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6441 527.605C78.7444 527.889 79.8896 527.223 79.937 526.088C79.9616 525.496 79.9325 524.901 79.8492 524.312C79.6695 523.041 79.2414 521.819 78.5891 520.713C77.9369 519.608 77.0734 518.642 76.0479 517.871C75.0224 517.1 73.855 516.538 72.6123 516.218C71.3697 515.897 70.0761 515.825 68.8055 516.005C67.5349 516.184 66.3121 516.612 65.207 517.265C64.1018 517.917 63.136 518.78 62.3646 519.806C62.0602 520.211 61.7551 520.507 61.4775 520.793C60.7282 521.566 61.2857 522.669 62.3056 523.014L70.1736 525.68L77.6441 527.605Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4814 525.092C55.4666 524.526 55.8204 523.249 55.0611 522.404C54.6652 521.964 54.2292 521.559 53.7578 521.195C52.7414 520.412 51.5808 519.836 50.342 519.501C49.1032 519.166 47.8106 519.079 46.5379 519.243C45.2653 519.408 44.0375 519.822 42.9248 520.461C41.812 521.1 40.836 521.952 40.0526 522.968C39.2691 523.985 38.6935 525.145 38.3586 526.384C38.0237 527.623 37.9361 528.916 38.1007 530.188C38.1657 530.691 38.1542 531.115 38.1558 531.514C38.1601 532.591 39.3292 532.99 40.3003 532.525L47.7918 528.934L54.4814 525.092Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2076 536.403C37.8783 535.486 37.6833 534.176 36.6462 533.711C36.1056 533.469 35.5427 533.276 34.9643 533.136C33.7175 532.832 32.4231 532.777 31.155 532.974C29.8869 533.171 28.6701 533.616 27.5738 534.283C26.4776 534.95 25.5235 535.827 24.7661 536.862C24.0086 537.898 23.4625 539.073 23.1591 540.32C22.8557 541.567 22.8009 542.861 22.9977 544.129C23.1945 545.397 23.6392 546.614 24.3063 547.711C24.5696 548.143 24.7316 548.536 24.8949 548.9C25.336 549.882 26.5665 549.772 27.265 548.953L32.6539 542.63L37.2076 536.403Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7495 586.611C26.9676 587.628 26.3938 588.79 26.0609 590.029C25.728 591.269 25.6424 592.561 25.8091 593.834C25.9757 595.106 26.3914 596.333 27.0323 597.445C27.6732 598.557 28.5268 599.531 29.5443 600.313C30.5619 601.095 31.7235 601.669 32.9628 602.002C34.2021 602.335 35.4949 602.42 36.7673 602.254C38.0396 602.087 39.2667 601.671 40.3785 601.03C41.4902 600.389 42.4649 599.536 43.2467 598.518L35.4981 592.564L27.7495 586.611Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4435 584.545L44.2874 598.886C44.5837 599.124 44.5452 599.586 44.2137 599.772C44.0224 599.879 43.785 599.859 43.6143 599.722L25.7999 585.344C25.5928 585.177 25.5479 584.879 25.6966 584.659C25.8644 584.409 26.2093 584.357 26.4435 584.545Z",
    fill: "#9E5D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0175 586.306C27.1165 585.614 25.8018 585.778 25.3131 586.804C25.0583 587.338 24.852 587.896 24.6976 588.471C24.3647 589.711 24.2791 591.003 24.4458 592.276C24.6124 593.548 25.0281 594.775 25.669 595.887C26.3099 596.999 27.1635 597.973 28.1811 598.755C29.1986 599.537 30.3602 600.111 31.5995 600.444C32.8388 600.777 34.1316 600.862 35.404 600.696C36.6764 600.529 37.9035 600.113 39.0152 599.472C39.5309 599.175 40.017 598.832 40.4682 598.448C41.3334 597.712 41.1531 596.399 40.2521 595.707L34.1348 591.007L28.0175 586.306Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5186 559.275C21.2652 559.55 20.0782 560.069 19.0255 560.803C17.9728 561.537 17.0749 562.471 16.3832 563.552C15.6914 564.633 15.2193 565.839 14.9938 567.103C14.7684 568.366 14.7939 569.661 15.069 570.915C15.3442 572.168 15.8635 573.355 16.5973 574.408C17.3311 575.46 18.2651 576.358 19.346 577.05C20.4268 577.742 21.6333 578.214 22.8966 578.439C24.1599 578.665 25.4552 578.639 26.7086 578.364L24.6136 568.82L22.5186 559.275Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9072 557.308C20.6538 557.583 19.4669 558.103 18.4142 558.836C17.3615 559.57 16.4636 560.504 15.7718 561.585C15.0801 562.666 14.608 563.872 14.3825 565.136C14.157 566.399 14.1826 567.694 14.4577 568.948C14.7328 570.201 15.2521 571.388 15.986 572.441C16.7198 573.494 17.6538 574.391 18.7347 575.083C19.8155 575.775 21.022 576.247 22.2853 576.473C23.5486 576.698 24.8439 576.672 26.0973 576.397L24.0023 566.853L21.9072 557.308Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.8673,
    cy: 560.456,
    rx: 37.2438,
    ry: 41.9301,
    transform: "rotate(33.9574 57.8673 560.456)",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 56.8885,
    cy: 559.727,
    rx: 35.3766,
    ry: 40.6301,
    transform: "rotate(33.9574 56.8885 559.727)",
    fill: "#F9DCB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0874 522.257C66.263 521.541 66.9532 521.072 67.6777 521.205C74.2554 522.409 80.1573 525.576 84.7151 530.363C89.5669 535.46 92.6777 542.164 93.6542 549.628C94.6306 557.092 93.4289 564.981 90.2009 572.296C86.973 579.612 81.8637 586.027 75.5194 590.729C69.175 595.43 61.8804 598.209 54.5581 598.712C47.2357 599.215 40.2145 597.42 34.3823 593.554C28.55 589.689 24.1687 583.927 21.7924 576.996C19.5348 570.411 19.1832 563.052 20.7663 555.765C20.9084 555.111 21.5365 554.688 22.1988 554.783C22.9609 554.891 23.4609 555.634 23.3039 556.388C21.918 563.039 22.2676 569.741 24.3274 575.748C26.5321 582.179 30.597 587.525 36.0079 591.111C41.4189 594.697 47.933 596.362 54.7264 595.896C61.5199 595.429 68.2875 592.852 74.1736 588.489C80.0597 584.127 84.7999 578.176 87.7947 571.389C90.7895 564.601 91.9045 557.282 90.9985 550.357C90.0926 543.432 87.2065 537.213 82.7052 532.484C78.5628 528.133 73.2237 525.225 67.2708 524.058C66.439 523.895 65.8853 523.08 66.0874 522.257Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.231 552.074C102.407 551.561 103.471 550.822 104.361 549.898C105.252 548.974 105.952 547.883 106.421 546.689C106.89 545.494 107.119 544.219 107.095 542.936C107.072 541.653 106.795 540.387 106.283 539.211C105.77 538.035 105.03 536.971 104.106 536.08C103.182 535.19 102.092 534.49 100.897 534.021C99.7029 533.552 98.4278 533.323 97.1447 533.346C95.8617 533.37 94.5959 533.646 93.4196 534.159L97.3252 543.117L101.231 552.074Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.4929 578.528C97.745 578.809 99.0401 578.841 100.304 578.621C101.569 578.402 102.778 577.935 103.862 577.249C104.946 576.562 105.884 575.669 106.623 574.62C107.362 573.57 107.887 572.386 108.168 571.134C108.449 569.882 108.481 568.587 108.261 567.322C108.042 566.058 107.576 564.849 106.889 563.765C106.202 562.681 105.309 561.743 104.26 561.004C103.211 560.265 102.026 559.74 100.774 559.459L98.6335 568.993L96.4929 578.528Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6099 596.822C79.492 597.755 80.549 598.504 81.7206 599.027C82.8922 599.551 84.1554 599.838 85.4382 599.874C86.721 599.909 87.9981 599.691 89.1968 599.233C90.3954 598.775 91.4921 598.085 92.4241 597.203C93.3561 596.321 94.1053 595.264 94.6289 594.092C95.1524 592.921 95.4401 591.658 95.4754 590.375C95.5107 589.092 95.2931 587.815 94.8348 586.616C94.3766 585.418 93.6868 584.321 92.8047 583.389L85.7073 590.106L78.6099 596.822Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6841 551.243L91.4678 534.065C91.1824 533.385 91.8768 532.708 92.5491 533.01C92.7194 533.086 92.8581 533.219 92.942 533.386L102.074 551.553C102.565 552.529 101.396 553.496 100.529 552.83L99.006 551.661C98.8642 551.552 98.7533 551.408 98.6841 551.243Z",
    fill: "#9E5D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2687 602.47C52.4015 603.746 52.7844 604.984 53.3956 606.113C54.0067 607.241 54.8341 608.238 55.8306 609.046C56.827 609.855 57.973 610.46 59.203 610.825C60.4331 611.191 61.7231 611.311 62.9994 611.178C64.2758 611.045 65.5135 610.662 66.6419 610.051C67.7702 609.44 68.7672 608.613 69.5758 607.616C70.3844 606.62 70.9888 605.474 71.3545 604.244C71.7203 603.014 71.8401 601.724 71.7073 600.447L61.988 601.459L52.2687 602.47Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.886 557.432L101.358 557.918C101.594 558.161 101.695 558.504 101.629 558.836L97.6356 578.85C97.4189 579.936 95.8744 579.959 95.6247 578.88L95.245 577.239C95.2115 577.094 95.2098 576.944 95.2399 576.799L99.1409 557.941C99.3082 557.132 100.311 556.84 100.886 557.432Z",
    fill: "#9E5D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3674 581.704L93.8462 582.384C94.1365 582.796 94.0855 583.358 93.7258 583.711L78.8201 598.338C78.3375 598.812 77.537 598.699 77.2042 598.11L76.563 596.976C76.3299 596.563 76.4086 596.045 76.7538 595.72L91.8217 581.547C92.2774 581.119 93.007 581.193 93.3674 581.704Z",
    fill: "#9E5D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7834 600.543L71.3998 599.695C71.7681 599.68 72.1063 599.897 72.2468 600.238C72.4783 600.799 72.0852 601.42 71.4792 601.451L49.8742 602.554C49.6992 602.563 49.525 602.526 49.3686 602.447C48.4423 601.978 48.7461 600.584 49.7834 600.543Z",
    fill: "#9E5D0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9448 601.162C50.8093 601.202 49.8997 602.165 50.1758 603.267C50.3197 603.842 50.5159 604.404 50.7628 604.945C51.295 606.113 52.0519 607.164 52.9904 608.039C53.929 608.915 55.0307 609.596 56.2327 610.046C57.4347 610.495 58.7134 610.703 59.9959 610.659C61.2783 610.614 62.5394 610.317 63.7071 609.785C64.8748 609.252 65.9263 608.495 66.8014 607.557C67.6766 606.618 68.3583 605.517 68.8077 604.315C69.0161 603.757 69.1727 603.183 69.2762 602.6C69.4747 601.481 68.5 600.584 67.3645 600.623L59.6547 600.893L51.9448 601.162Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1316 550.145C99.6132 551.174 100.856 551.633 101.762 550.947C102.234 550.589 102.674 550.188 103.075 549.749C103.941 548.802 104.611 547.693 105.049 546.487C105.486 545.28 105.681 543.999 105.623 542.717C105.565 541.435 105.256 540.177 104.712 539.015C104.168 537.853 103.4 536.809 102.453 535.944C101.505 535.078 100.397 534.407 99.1903 533.97C97.9838 533.533 96.7031 533.338 95.4211 533.396C94.9152 533.418 94.4927 533.371 94.0952 533.34C93.0218 533.254 92.5263 534.386 92.909 535.392L95.8613 543.157L99.1316 550.145Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8268 593.981C79.0016 594.762 78.9568 596.087 79.8929 596.73C80.381 597.066 80.8998 597.357 81.4432 597.6C82.6148 598.124 83.8781 598.411 85.1608 598.447C86.4436 598.482 87.7208 598.264 88.9194 597.806C90.1181 597.348 91.2147 596.658 92.1468 595.776C93.0788 594.894 93.828 593.837 94.3515 592.665C94.8751 591.494 95.1627 590.231 95.1981 588.948C95.2334 587.665 95.0157 586.388 94.5575 585.189C94.345 584.633 94.0826 584.099 93.7743 583.593C93.183 582.623 91.8584 582.595 91.0332 583.376L85.43 588.679L79.8268 593.981Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0599 575.434C95.8354 576.548 96.5618 577.656 97.6979 577.643C98.2903 577.636 98.8822 577.575 99.4662 577.46C100.725 577.213 101.924 576.72 102.992 576.01C104.061 575.3 104.98 574.386 105.695 573.321C106.411 572.256 106.91 571.06 107.163 569.802C107.417 568.544 107.42 567.249 107.173 565.989C106.926 564.73 106.433 563.532 105.723 562.463C105.012 561.394 104.099 560.476 103.033 559.76C102.539 559.428 102.017 559.143 101.474 558.907C100.431 558.455 99.3326 559.195 99.1081 560.309L97.584 567.872L96.0599 575.434Z",
    fill: "#F5C58A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M856.696 747.731L812.424 709.566C811.345 708.636 809.92 708.21 808.507 708.396L807.195 708.569C802.955 709.127 801.328 714.405 804.516 717.254L847.967 756.082C849.373 757.339 851.367 757.698 853.123 757.009L855.256 756.173C858.762 754.799 859.548 750.189 856.696 747.731Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.803 684.904L953.45 659.705C952.509 659.102 951.379 658.866 950.274 659.041C946.216 659.684 945.006 664.94 948.374 667.293L985.882 693.498C987.012 694.288 988.419 694.576 989.769 694.294L991.13 694.009C995.513 693.093 996.574 687.319 992.803 684.904Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.214 726.854L972.575 575.157L981.735 576.131L834.779 732.105C833.375 733.595 831.047 733.716 829.496 732.379C827.844 730.955 827.715 728.439 829.214 726.854Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.008 613.159L833.759 607.664C833.13 607.327 832.414 607.191 831.705 607.273C828.229 607.679 827.446 612.379 830.604 613.889L964.749 678.02C967.945 679.548 971.304 676.248 969.833 673.026C969.459 672.207 968.806 671.548 967.991 671.167L844.008 613.159Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M992.043 521.321L726.164 578.007L760.387 618.794L1022.24 543.398L1018.79 535.96L997.466 522.306C995.858 521.277 993.91 520.923 992.043 521.321Z",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.466 675.007L1053.53 575.007L1054.42 566.617L796.466 659.507L796.466 675.007Z",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.54 543.324L747.327 615.284L795.664 660.507L1054.42 566.617L1021.54 543.324Z",
    fill: "#818A98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.609 624.048C779.306 622.435 780.067 620.016 782.058 619.439L790.392 617.023C791.463 616.713 792.617 617.043 793.361 617.874L811.644 638.29C813.023 639.83 812.395 642.276 810.446 642.962L801.044 646.271C799.886 646.679 798.596 646.313 797.825 645.358L780.609 624.048Z",
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.824 607.776L706.266 579.202L790.887 664.461L790.887 681.507L712.231 612.325C710.899 611.154 710.043 609.535 709.824 607.776Z",
    fill: "#22262A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.399 576.582L706.165 579.507L790.664 664.507L801.164 660.507L730.078 578.967C728.419 577.063 725.889 576.16 723.399 576.582Z",
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.162 677.007L801.162 660.007L790.886 664.461L790.886 681.507L801.162 677.007Z",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.816 535.495L960.669 533.755C960.038 533.406 959.3 533.305 958.598 533.47L877.07 552.73C874.79 553.269 874.056 556.15 875.801 557.713L879.778 561.276C880.502 561.925 881.505 562.168 882.446 561.922L963.145 540.84C965.679 540.178 966.108 536.763 963.816 535.495Z",
    fill: "#67717E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.22 569.007L1013.4 546.701L790.064 605.686L828.664 648.007L828.664 655.507L1044.22 574.007L1044.22 569.007Z",
    fill: "#D5D8DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.216 628.092L799.599 602.711C798.161 601.286 798.791 598.839 800.739 598.286C801.648 598.029 802.626 598.275 803.304 598.933L829.186 624.043C830.678 625.491 830.156 627.998 828.211 628.731C827.174 629.122 826.004 628.872 825.216 628.092Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.201 604.71L870.953 585.738C869.443 584.389 870.009 581.907 871.954 581.345C872.792 581.104 873.696 581.303 874.355 581.876L895.853 600.565C897.428 601.933 896.975 604.486 895.026 605.231C894.061 605.599 892.971 605.398 892.201 604.71Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.598 583.738L936.559 568.764C935.06 567.644 935.427 565.31 937.193 564.732C937.917 564.494 938.715 564.633 939.323 565.102L959.126 580.388C960.451 581.41 960.134 583.484 958.568 584.04C957.905 584.275 957.165 584.162 956.598 583.738Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.02 564.036L995.828 552.685C994.392 551.612 994.684 549.387 996.345 548.747C997.085 548.462 997.924 548.587 998.556 549.076L1013.55 560.683C1014.87 561.708 1014.56 563.783 1012.99 564.338C1012.33 564.574 1011.58 564.46 1011.02 564.036Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.372 618.868L830.615 595.822C829.162 594.411 829.777 591.956 831.724 591.399C832.621 591.142 833.586 591.378 834.262 592.02L858.279 614.795C859.789 616.226 859.283 618.743 857.338 619.481C856.314 619.87 855.158 619.631 854.372 618.868Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.174 595.762L898.295 577.574C896.937 576.392 897.386 574.178 899.099 573.606C899.895 573.34 900.77 573.52 901.392 574.078L922.001 592.571C923.196 593.643 922.809 595.605 921.295 596.155C920.567 596.419 919.755 596.268 919.174 595.762Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.795 575.066L962.516 561.898C961.093 560.814 961.451 558.587 963.14 558.024C963.85 557.787 964.633 557.925 965.224 558.392L982.275 571.854C983.532 572.846 983.22 574.826 981.723 575.366C981.074 575.6 980.347 575.487 979.795 575.066Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.476 624.348L811.498 599.727C810.055 598.306 810.683 595.857 812.631 595.304C813.536 595.047 814.509 595.291 815.186 595.944L840.429 620.295C841.926 621.738 841.408 624.248 839.462 624.981C838.428 625.371 837.263 625.124 836.476 624.348Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.763 601.068L881.883 583.122C880.362 581.815 880.901 579.342 882.828 578.786C883.658 578.546 884.554 578.749 885.201 579.322L905.798 597.592C907.139 598.781 906.672 600.979 904.962 601.518C904.201 601.759 903.369 601.589 902.763 601.068Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M965.299 580.358L945.877 565.466C944.39 564.326 944.771 561.997 946.539 561.417C947.28 561.174 948.097 561.321 948.712 561.809L967.893 577.013C969.205 578.054 968.875 580.123 967.307 580.679C966.63 580.919 965.874 580.798 965.299 580.358Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.19 560.631L1005.5 550.142C1004.01 548.995 1004.37 546.653 1006.14 546.043C1006.91 545.778 1007.76 545.929 1008.4 546.442L1021.82 557.27C1023.13 558.325 1022.79 560.396 1021.21 560.954C1020.53 561.196 1019.77 561.074 1019.19 560.631Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.892 615.586L840.15 592.429C838.711 591.025 839.353 588.589 841.297 588.076C842.163 587.848 843.086 588.084 843.736 588.7L867.801 611.521C869.31 612.952 868.805 615.467 866.862 616.204C865.836 616.593 864.678 616.352 863.892 615.586Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.254 592.526L907.36 574.901C905.989 573.745 906.421 571.529 908.127 570.959C908.91 570.697 909.77 570.873 910.384 571.42L930.8 589.594C931.857 590.535 931.574 592.257 930.271 592.821C929.595 593.113 928.814 592.998 928.254 592.526Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M988.116 571.823L971.463 559.26C970.035 558.184 970.388 555.955 972.075 555.393C972.78 555.158 973.557 555.293 974.145 555.753L990.575 568.608C991.835 569.594 991.528 571.575 990.031 572.115C989.386 572.348 988.666 572.238 988.116 571.823Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.463 611.996L851.045 590.062C849.577 588.687 850.169 586.238 852.102 585.685C852.989 585.43 853.945 585.668 854.61 586.309L877.713 608.575C879.003 609.818 878.491 611.989 876.782 612.525C875.97 612.78 875.084 612.578 874.463 611.996Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M936.015 589.089L916.315 571.662C914.967 570.469 915.423 568.26 917.136 567.688C917.942 567.418 918.828 567.605 919.453 568.176L938.881 585.906C940.067 586.987 939.672 588.945 938.159 589.494C937.422 589.762 936.6 589.606 936.015 589.089Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.061 568.595L980.408 556.033C978.981 554.956 979.334 552.727 981.021 552.165C981.725 551.93 982.502 552.065 983.09 552.525L999.52 565.38C1000.78 566.366 1000.47 568.348 998.976 568.887C998.332 569.12 997.611 569.01 997.061 568.595Z",
    fill: "#3A3F46"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_5356_19183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M827.165 648.507L1052.66 566.507",
    stroke: "#818A98",
    strokeWidth: 1.45038
  })), /*#__PURE__*/React.createElement("path", {
    d: "M214.945 646.472L247.09 623.068L247.639 635.056L216.139 660.614L214.945 646.472Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.883 622.596L247.091 623.068L214.945 646.472L216.139 660.614L208.971 658.017C207.857 657.613 207.048 656.638 206.856 655.468L205.349 646.254C205.144 644.999 205.685 643.738 206.736 643.022L235.872 623.16C236.463 622.757 237.169 622.559 237.883 622.596Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.574 650.127L327.358 680.731L332.432 672.308L220.324 644.678L220.574 650.127Z",
    fill: "#7E4B09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.457 672.853L338.127 665.495L224.584 642.299L220.324 644.679L332.457 672.853Z",
    fill: "#A0600F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.565 635.607L352.089 648.475L356.719 642.257L239.365 631.248L239.565 635.607Z",
    fill: "#7E4B09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.08 628.894L360.309 637.178L356.199 642.827L239.365 631.248L243.08 628.894Z",
    fill: "#A0600F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.131 687.427L378.561 630.337L376.765 648.196C376.712 648.716 376.536 649.216 376.251 649.654L339.954 705.408L339.131 687.427Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.876 628.729L379.025 629.542L339.63 687.404L340.453 705.385L325.719 700.346C324.478 699.922 323.61 698.798 323.514 697.49L322.442 682.934C322.383 682.132 322.621 681.336 323.111 680.698L362.094 630.002C362.754 629.144 363.795 628.667 364.876 628.729Z",
    fill: "#D37D12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.742 632.291C351.457 631.818 345.267 631.414 342.439 631.305C341.557 631.271 340.733 631.652 340.147 632.311L306.021 670.701C305.491 671.296 305.758 672.24 306.52 672.47L320.017 676.55C321.301 676.938 322.691 676.503 323.526 675.453L356.448 634.02C356.974 633.359 356.582 632.383 355.742 632.291Z",
    fill: "#516D95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.016 630.698C332.203 630.381 327.608 630.446 325.3 630.513C324.472 630.537 323.692 630.888 323.112 631.48L289.868 665.45C289.3 666.03 289.542 667.005 290.316 667.252L300.317 670.445C301.55 670.838 302.899 670.468 303.759 669.501L336.689 632.443C337.268 631.791 336.885 630.77 336.016 630.698Z",
    fill: "#52BDA4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.042 629.999C315.166 629.685 310.464 629.738 308.171 629.797C307.389 629.818 306.65 630.133 306.08 630.669L274.257 660.646C273.649 661.219 273.885 662.235 274.683 662.482L283.702 665.27C284.862 665.629 286.124 665.316 286.983 664.458L319.671 631.783C320.308 631.145 319.94 630.071 319.042 629.999Z",
    fill: "#F1AE5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.666 629.217C298.412 628.921 295.298 628.924 293.55 628.965C292.811 628.982 292.106 629.266 291.549 629.752L261.13 656.265C260.491 656.822 260.703 657.862 261.509 658.124L268.377 660.362C269.509 660.73 270.753 660.455 271.623 659.642L302.268 631.039C302.939 630.413 302.581 629.3 301.666 629.217Z",
    fill: "#ED972C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.525 628.341C284.527 628.053 281.96 628.035 280.434 628.064C279.732 628.078 279.06 628.338 278.516 628.782L249.084 652.797C248.41 653.347 248.619 654.426 249.45 654.684L255.725 656.63C256.815 656.968 258.002 656.714 258.858 655.96L288.103 630.19C288.804 629.573 288.454 628.43 287.525 628.341Z",
    fill: "#EA7362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.856 627.941C271.021 627.665 268.741 627.638 267.345 627.662C266.679 627.674 266.039 627.911 265.509 628.315L238.019 649.306C237.315 649.844 237.512 650.952 238.358 651.215L243.624 652.847C244.667 653.17 245.802 652.952 246.651 652.265L274.4 629.819C275.143 629.219 274.807 628.033 273.856 627.941Z",
    fill: "#AA6F9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.228 627.483C258.867 627.223 257.33 627.165 256.264 627.172C255.626 627.176 255.013 627.396 254.496 627.77L228.914 646.256C228.193 646.777 228.365 647.895 229.208 648.176L233.122 649.476C234.15 649.818 235.281 649.629 236.142 648.971L261.746 629.397C262.516 628.808 262.191 627.589 261.228 627.483Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.652 626.952C248.488 626.702 247.183 626.634 246.234 626.633C245.593 626.632 244.975 626.857 244.457 627.235L221.293 644.102C220.575 644.624 220.748 645.739 221.59 646.019L224.564 647.009C225.581 647.348 226.699 647.167 227.557 646.525L251.161 628.88C251.942 628.296 251.621 627.063 250.652 626.952Z",
    fill: "#33717F"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 343.856,
    cy: 637.797,
    rx: 3.75195,
    ry: 2.5013,
    transform: "rotate(3.94562 343.856 637.797)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 326.397,
    cy: 636.088,
    rx: 3.39014,
    ry: 2.26009,
    transform: "rotate(3.94562 326.397 636.088)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 308.506,
    cy: 635.033,
    rx: 3.5548,
    ry: 2.36986,
    transform: "rotate(3.94562 308.506 635.033)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 292.811,
    cy: 633.314,
    rx: 2.99426,
    ry: 1.99618,
    transform: "rotate(3.94562 292.811 633.314)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.536,
    cy: 632.75,
    rx: 2.77495,
    ry: 1.84997,
    transform: "rotate(3.94562 279.536 632.75)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 266.659,
    cy: 631.516,
    rx: 2.29918,
    ry: 1.53278,
    transform: "rotate(3.94562 266.659 631.516)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 254.682,
    cy: 630.362,
    rx: 2.10353,
    ry: 1.40236,
    transform: "rotate(3.94562 254.682 630.362)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245.645,
    cy: 629.775,
    rx: 2.10353,
    ry: 1.40236,
    transform: "rotate(3.94562 245.645 629.775)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 320.12,
    cy: 666.65,
    rx: 3.70297,
    ry: 2.46865,
    transform: "rotate(3.94562 320.12 666.65)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 302.198,
    cy: 661.938,
    rx: 3.52012,
    ry: 2.34674,
    transform: "rotate(3.94562 302.198 661.938)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.268,
    cy: 657.932,
    rx: 3.31302,
    ry: 2.20868,
    transform: "rotate(3.94562 285.268 657.932)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.75,
    cy: 654.39,
    rx: 2.99426,
    ry: 1.99618,
    transform: "rotate(3.94562 269.75 654.39)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 257.338,
    cy: 650.784,
    rx: 2.77495,
    ry: 1.84997,
    transform: "rotate(3.94562 257.338 650.784)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.778,
    cy: 648.05,
    rx: 2.38131,
    ry: 1.58754,
    transform: "rotate(3.94562 244.778 648.05)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 234.262,
    cy: 645.797,
    rx: 2.26013,
    ry: 1.50675,
    transform: "rotate(3.94562 234.262 645.797)",
    fill: "#505862"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.924,
    cy: 643.551,
    rx: 1.96598,
    ry: 1.31065,
    transform: "rotate(3.94562 225.924 643.551)",
    fill: "#505862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5356_19183",
    x: 127.562,
    y: 64.9898,
    width: 469.122,
    height: 743.454,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5356_19183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_5356_19183",
    x: 372.656,
    y: 61.6742,
    width: 486.653,
    height: 718.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5356_19183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_5356_19183",
    x: 360.255,
    y: 70.0563,
    width: 503.552,
    height: 701.887,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5356_19183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_5356_19183",
    x: 445.589,
    y: 70.7622,
    width: 625.8,
    height: 721.939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.22187,
    result: "effect1_foregroundBlur_5356_19183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_5356_19183",
    x: 821.116,
    y: 565.825,
    width: 237.597,
    height: 94.9661,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.80153
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.90076
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5356_19183"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5356_19183",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5356_19183",
    x1: 139.998,
    y1: 36.5,
    x2: 175.919,
    y2: 448.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1AD5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5356_19183",
    x1: 415.924,
    y1: 40.7359,
    x2: 534.137,
    y2: 493.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F17F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1885B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5356_19183",
    x1: 752.5,
    y1: 81,
    x2: 556.473,
    y2: 416.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BF1BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835344,
    stopColor: "#5BF1CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5356_19183",
    x1: 1050,
    y1: 81,
    x2: 683.251,
    y2: 410.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1AC5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.696714,
    stopColor: "#F1AD5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5356_19183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 800,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMusicBand);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MusicBand.48532e240c04d7e1f33fb7146d00abbf.svg";